import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ProductsLayout from "./components/ProductsLayout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Gallery from "./pages/Gallery";
import ProductProp from "./components/ProductProp";
import ShadyLane from "./pages/products/ShadyLane";
import SeccoChimneys from "./pages/products/SeccoChimneys";

function App() {
	return (
		<Router>
			<div className="flex min-h-screen flex-col bg-[#071428]">
				<Header />
				<main className="bg-white">
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/gallery" element={<Gallery />} />
						<Route path="/products" element={<ProductsLayout />}>
							<Route index element={<Products />} />
							<Route
								path="shady-lane"
								element={<ShadyLane />}
							/>
							<Route
								path="secco-chimneys"
								element={<SeccoChimneys />}
							/>
							<Route
								path=":productName"
								element={<ProductProp />}
							/>
						</Route>
					</Routes>
				</main>
				<Footer />
			</div>
		</Router>
	);
}

export default App;
